import React from 'react';

import { YesNoDisplay } from '@components/admin/members/MembershipFormDetails/Forms';
import Collapse from '@material-ui/core/Collapse';
import { ChecklistForm, MembershipFormFields } from '@models/MembershipForm';
import { makeMuiStyles } from '@styles';
import { createStrings } from '@utils/local';
export const strings = createStrings({
  ja: {
    question1: '1、リアルタイム口座をお持ちですか？',
    question2: '2、延納口座をお持ちですか？',
    question3: '3、輸出入者符号を取得されていますか？',
  },
});

const useStyles = makeMuiStyles((_, common) => ({
  formContainer: {
    ...common.flexColumn,
    marginBottom: '1rem',
  },
}));

export const ChecklistDisplay: React.FC<{ values: ChecklistForm; expand: boolean }> = ({
  values,
  expand,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.formContainer}>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <YesNoDisplay
          field={{ ...MembershipFormFields.shared.question2, label: strings.question1 }}
          value={values.question2}
        />
        <YesNoDisplay
          field={{ ...MembershipFormFields.shared.question3, label: strings.question2 }}
          value={values.question3}
        />
        <YesNoDisplay
          field={{ ...MembershipFormFields.shared.question5, label: strings.question3 }}
          value={values.question6}
        />
      </Collapse>
    </div>
  );
};
